import { useMemo } from "react";
import { qrMatrix, qrPath } from "../lib/referralLink";

const QUIET = 2;

/**
 * The invite QR code (#1571, D417): an SVG drawn in the browser from `value`
 * (the join link), no network and no image file. The quiet zone is part of the
 * drawing and the background is white, so it scans on any card colour.
 * `data-qr-text` carries exactly what is encoded, for the tests.
 */
export default function ReferralQr({ value, size = 168 }) {
  const { d, n } = useMemo(() => {
    const m = qrMatrix(value);
    return { d: qrPath(m, QUIET), n: m.length };
  }, [value]);
  const box = n + QUIET * 2;
  return (
    <svg
      role="img"
      aria-label="QR code for your invite link"
      data-testid="referral-qr"
      data-qr-text={value}
      viewBox={`0 0 ${box} ${box}`}
      width={size}
      height={size}
      shapeRendering="crispEdges"
      style={{ display: "block", maxWidth: "100%", height: "auto", aspectRatio: "1 / 1", background: "#FFFFFF", borderRadius: 8, border: "1px solid var(--nw-line)" }}
    >
      <rect width={box} height={box} fill="#FFFFFF" />
      <path d={d} fill="#0F172A" />
    </svg>
  );
}
